import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientAccountReceivableRow } from "../../pages/app/provider/billings/account-receivable/patient/AccountReceivablePatientTable";
import { AccountReceivableControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  payerType?: string;
  searchString?: string;
  startDate?: string;
  endDate?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export const usePatientAccountReceivable = ({
  pagination,
  gridSorting,
  payerType,
  searchString,
  startDate,
  endDate,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<PatientAccountReceivableRow> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "patient-account-receivable",
      pageIndex,
      pageSize,
      gridSorting,
      payerType,
      searchString,
      startDate,
      endDate,
      xTENANTID,
      sortData,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
    queryFn: async () =>
      await new AccountReceivableControllerApi(getConfigObject())
        .getPatientAccountReceivable(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, //sortDirection
          payerType,
          searchString,
          startDate,
          endDate,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
